import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Select from 'react-select'
import {v4 as uuidv4}  from 'uuid'
import formatNumbers from 'util/formatNumbers';

import {dispatchAction, displayMessage, makeRequest} from 'actions';
import {
  ADD_SELECTED_TRANSACTIONS,
  ADD_TRANSACTION,
  CLEAR_SELECTED_TRANSACTIONS,
  FETCH_TRANSACTIONS,
  RESET_TRANSACTIONS,
  UPDATE_TRANSACTION
} from "actions/actionTypes";
import AdminTransactionsSearchBox from 'dashboard/transactions/AdminTransactionsSearchBox'
import config from '../../../config';
import queryString from 'query-string'
import {fetchAllSellersList} from 'shared/sharedMethods';
import AdminTransactionsListTable from 'dashboard/transactions/AdminTransactionsListTable';
import PaginationBox from 'shared/PaginationBox';
import {Button, Checkbox, Col, ControlLabel, Form, FormControl, FormGroup, Modal, Row} from 'react-bootstrap';
import AdminTransactionsActionsBox from "./AdminTransactionsActionsBox";
import RemoveModalDialog from 'shared/RemoveModalDialog';
import _ from 'lodash';
import {base64ToHex, prepareSelectOptionsList} from 'util/Utils';
import {calculateTransactionPayoutAmount} from 'dashboard/transactions/transactionsPageMethods';

var async = require('async');
var transactionTypes = [
    {value: 'Sale', label: 'Sale'},
    {value: 'Fee', label: 'Fee'},
    {value: 'PickupFee', label: 'Pickup Fee'},
    {value: 'Credit', label: 'Credit'},

];

export class TransactionsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props, context) {
        super(props, context);
        this.state = {
            errors: {},
            PayoutNote: '',
            selectAllRecords: false,
            pending: false,
            formData: {
                Description: '',
                Seller: false,
                Type: '',
                Amount: '',
                selectedProduct: {},
                selectedService:{},
                Status: '',
                sellerProducts: [],
                OrderID: '',
                PayoutPercentage: '',
                ProductBasePriceWithDiscount:''
            },
            matchingFeeTransactions:{
                fetched:false,
            },
            dataToDisplay: [],
            currentRecord: false,
            showAddFeeModal: false,
            sortBy: '',
            selectedUser: false,
            displayGeneratePayoutBox: false,
            SellerID: this.props.adminTransactions.SellerID,
            sendEmailToUser: false,

        };
        this.searchBox = false;


    };

    componentWillMount() {
        fetchAllSellersList.call(this)
        this.setState({
            sellersOptionsList: prepareSelectOptionsList(this.props.allSellersList.data, {
                label: 'DisplayName',
                value: '_id'
            })
        })


    }

    componentWillReceiveProps(nextProps) {
        if (_.size(nextProps.allSellersList.data) !== _.size(this.props.allSellersList.data)) {
            this.setState({
                sellersOptionsList: prepareSelectOptionsList(nextProps.allSellersList.data, {
                    label: 'DisplayName',
                    value: '_id'
                })
            })
        }
    }

    resetSearch() {
        this.props.dispatchAction({}, RESET_TRANSACTIONS)
        this.setState({
            SellerID: false,
            sortBy: '',
            displayGeneratePayoutBox: false,
        });
    }

    setSearchParams(params) {
        this.searchBox.setSearchParams(params);
    }

    fetchSelectedUserData(UserID) {
        if (!UserID) {
            this.setState({selectedUser: false})
            return;
        }


        var methodData = {
            'endpoint': '/sellers/' + encodeURIComponent(UserID),
            'not_display_success_message': true
        };

        return this.props.makeRequest({}, methodData).then(function (res) {
            this.setState({selectedUser: res.data})
        }.bind(this)).catch(err => {
            this.setState({selectedUser: false})
        });
    }

     search(params = {}) {
         if (this.state.pending){
             return this.props.displayMessage({
                 'messageType': 'warning',
                 'messageCode': 'Please wait till search request is completed'
             });
         }
         this.setState({pending:true})

        var {queryParams} = this.searchBox.getSearchParams();

        _.extend(queryParams, params);
        if (this.state.sortBy) {
            queryParams.sortBy = this.state.sortBy;
            queryParams.sortBySecondary = '_id:-1';
            /* without secondary sort query, the order of documents with the same fields is not guaranteed across pages */
        }
        if (queryParams.SellerID) {
            if (queryParams.Statuses.length  ==1 && _.get(queryParams, 'Statuses.0') =='Sold') {
                queryParams.all = true;
            }
            this.setState({SellerID: queryParams.SellerID});

        } else { /* when selecting 'all' sellers */
            this.setState({SellerID: false});
        }
        queryParams.addFields = ['LatestPayoutRequestDate', 'FundsAvailableForPaymentAt']
       queryParams.useAnalyticDatabase = true
        var methodData = {
            "endpoint": "/transactions",
            'not_display_success_message': true
        };
        if (_.isUndefined(params.include)) {
            methodData['success_event'] = FETCH_TRANSACTIONS;

            methodData['success_event_data'] = {
                'SellerID': queryParams.SellerID ? queryParams.SellerID : false,
            }
        }
        if (_.isUndefined(params.page)) { /* do not clear selected transactions when only pagination is changed */
            this.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
        }
        

        /* queryParams.all is used when either recordIDs are passed or SellerID and Sold status is selected*/
        if (queryParams.all  && !_.isUndefined(params.page) && this.props.adminTransactions.data.length > 300) {
            var from = (queryParams.page - 1) * queryParams.perPage
            var to = from + parseInt(queryParams.perPage)
             this.setState({dataToDisplay: this.props.adminTransactions.data.slice(from, to), pending:false})
            return;
        }

        queryParams.projectFields = {/*  ProductID can include a lot of ChangeLogs and Transactions and overall it can be a lot of data */
            ProductID:'unset',
            "ProductID.ProductName": "$ProductID.ProductName",
            "ProductID._id": "$ProductID._id",
            "ProductID.Payout": "$ProductID.Payout",
        }
        if (queryParams.page == 1) {
            queryParams.page = undefined;
        }

        queryParams.lookup = ['Sellers', 'Users', 'Contractors']
        const stringified = queryString.stringify(_.omit(queryParams, ['include', 'addFields','projectFields', 'page', 'lookup',   'all', 'sortBySecondary']));
        this.context.router.push('/admin/payout-registry?' + stringified);
        return this.props.makeRequest(queryParams, methodData).then(function (res) {
            this.setState({pending: false})
            if (this.refs.pagination && _.isUndefined(queryParams.page)) {
                this.refs.pagination.resetPagination();
            }

             if (_.isUndefined(params.include)) {
                 var dataToDisplay = []
                if ( queryParams.all && res.data.total > 300) {
                    dataToDisplay = res.data.data.slice(0, queryParams.perPage)
                }
                 this.setState({ matchingFeeTransactions:{fetched:false}, dataToDisplay: dataToDisplay})
           }

            return res;
        }.bind(this)).catch(err => {
            this.setState({pending: false})
        });

    }
    searchFeeTransactions(){
        let self = this;
        let searchBoxParams= this.searchBox.getSearchParams();
        let queryParams ={
            all:true,
            SellerID:searchBoxParams.queryParams.SellerID,
           Statuses:['Sold', 'PendingPayout'],
            doNotGetTotal:true,
            Types:['Fee'],
            doNotLookupProducts:true,
            sortBy: 'createdAt:1',
        }
        if(this.props.adminTransactions.total<=250){
           delete queryParams.all
            queryParams.perPage = this.props.adminTransactions.total
        }


         return this.props.makeRequest(queryParams, {
            "endpoint": "/transactions",
            'not_display_success_message': true
        }).then(function (res) {
              self.setState({pending: false})
             if(res.data.total ==0){
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'No Fee transactions in Pending status found for this seller'
                });
            }

             let feeTransactions  =res.data.data.slice(0, self.props.adminTransactions.total)
              feeTransactions.forEach((transaction)=>{
                  transaction.SellerID=self.props.adminTransactions.data[0].SellerID
                  transaction.ProductID= {_id:transaction.ProductID}
             })
             self.setState({matchingFeeTransactions:{
                 fetched:true,
                  data:feeTransactions,
                  total:   feeTransactions.length
                 }})
              let transactionsToUpdate = []
             self.props.adminTransactions.data.forEach((transaction,index)=>{
                 transactionsToUpdate.push(transaction)
                 if(feeTransactions[index]){
                     transactionsToUpdate.push(feeTransactions[index])
                 }
             })
              self.props.dispatchAction({
                 data:transactionsToUpdate,
                 total:transactionsToUpdate.length,
             }, FETCH_TRANSACTIONS)
            return res;
        }).catch(err => {
             self.setState({pending: false})
             return  Promise.reject(err)
         });
    }

  prepareTransactionsForPayment(amountToPay) {
    let totalPayout = 0;
    let transactionsToUpdate = []
    let useAdditionalSaleTransactions = false
    let index = 0
    let latestFeeTransaction = false
    const feeTransactions = this.props.adminTransactions.data.filter(record => {
      return record.Type == 'PickupFee' || record.Type == 'Fee'
    })
    const saleTransactions = this.props.adminTransactions.data.filter(record => {
      return record.Type == 'Sale'
    })
    for (index; index < saleTransactions.length; index++) { /* add one sale and one fee transaction (if it exists) for each loop run*/
      totalPayout +=  calculateTransactionPayoutAmount(saleTransactions[index], this.props.appData.FeatureFlags);
      transactionsToUpdate.push(saleTransactions[index])
      if (feeTransactions[index]) {
        totalPayout -= formatNumbers.unformat(formatNumbers.toFixed(feeTransactions[index].Amount, 2))
        transactionsToUpdate.push(feeTransactions[index])
      }
      totalPayout = formatNumbers.unformat(formatNumbers.toFixed(totalPayout, 2))

      if (amountToPay > 1000 && totalPayout > (amountToPay - 100)) {  /* if amount is more than 1000, stop the loop when total payout is greater than specified amount minus 100 to be able to add sale transactions with smaller amount*/
        useAdditionalSaleTransactions = true;
        break;
      }
      if (totalPayout >= amountToPay) {
        break;
      }
    }

    if (useAdditionalSaleTransactions) { /* add sale transactions with smaller amounts to use smaller number of fee transactions to reduce total amount later */
      const saleTransactionsSorted = _.orderBy(saleTransactions.slice(index + 1), item => {
        return calculateTransactionPayoutAmount(item, this.props.appData.FeatureFlags);
      }, 'asc');
       let smallerTransactionsIndex = 0;

      for (smallerTransactionsIndex; smallerTransactionsIndex < saleTransactionsSorted.length; smallerTransactionsIndex++) {
        index++;
        totalPayout += calculateTransactionPayoutAmount(saleTransactionsSorted[smallerTransactionsIndex], this.props.appData.FeatureFlags);
        transactionsToUpdate.push(saleTransactionsSorted[smallerTransactionsIndex])
        if (feeTransactions[index]) {
          totalPayout -= formatNumbers.unformat(formatNumbers.toFixed(feeTransactions[index].Amount, 2))
          transactionsToUpdate.push(feeTransactions[index])
        }
        totalPayout = formatNumbers.unformat(formatNumbers.toFixed(totalPayout, 2))
        if (totalPayout >= amountToPay) {
          break;
        }
      }
    }
    if (totalPayout > amountToPay && feeTransactions[index + 1]) { /* include fee transactions to reduce amount*/
      for (index++; index < feeTransactions.length; index++) {/* increase latest index to not add the same fee transaction*/
        totalPayout = formatNumbers.unformat(formatNumbers.toFixed(totalPayout - feeTransactions[index].Amount, 2))
        transactionsToUpdate.push(feeTransactions[index])
        latestFeeTransaction = _.cloneDeep(feeTransactions[index])
        if (totalPayout <= amountToPay) {
          break;
        }
      }
    }
    const transactionsToSelectIDs = transactionsToUpdate.map(item => item._id)
    const orderedTransactions = _.orderBy(this.props.adminTransactions.data, item => {
      if (transactionsToSelectIDs.includes(item._id)) return 1
      return 0
    }, ['desc']);

     if (formatNumbers.unformat(formatNumbers.toFixed(totalPayout, 2)) < amountToPay && latestFeeTransaction) {/* transfer amount of the latest fee transaction if total amount is less than specified amount */
      latestFeeTransaction.AmountToTransfer = Math.abs(formatNumbers.unformat(formatNumbers.toFixed(totalPayout - amountToPay, 2)))
      latestFeeTransaction.Amount = formatNumbers.unformat(formatNumbers.toFixed(latestFeeTransaction.Amount - latestFeeTransaction.AmountToTransfer, 2))
      this.editTransaction(latestFeeTransaction)
    } else if (formatNumbers.unformat(formatNumbers.toFixed(totalPayout, 2)) > amountToPay) { /* no additional fee transaction to reduce total amount*/
      this.props.displayMessage({
        'messageType': 'warning',
        'messageCode': 'Please, adjust total amount manually'
      });
    }
    this.props.dispatchAction({
      data: orderedTransactions,
      total: orderedTransactions.length,
    }, FETCH_TRANSACTIONS)

    this.toggleAllRecordsSelection(true)
    this.props.dispatchAction(transactionsToUpdate, ADD_SELECTED_TRANSACTIONS)
    return totalPayout

  }
    toggleAllRecordsSelection(value) {
        if (value) {
            this.setState({selectAllRecords: true});
        } else {
            this.setState({selectAllRecords: false});
        }
    }

    deleteTransaction(row) {
        var self = this
        this.setState({removeRecordModalVisible: false});
        var methodData = {
            type: 'patch',
            "endpoint": "/transactions/updateDeleted/" + encodeURIComponent(this.state.currentRecord._id),
            'success_event_data': {
                'TransactionID': this.state.currentRecord._id
            },
            messageCode: 'Transaction has been set as Deleted'
        };
        this.setState({currentRecord: false});
        this.props.makeRequest({}, methodData).then(function () {
            self.search()
        }).catch(err => {
            // A mensagem would be nice here
        });
    }

    showRemoveDialog(row) {
        this.setState({removeRecordModalVisible: true, currentRecord: row});
    }

    editTransaction(row) {
        this.onFormSellerChange({value: row.SellerID._id});
        this.setState({
            showAddFeeModal: true,
            currentRecord: row,
            formData: {
                Description: row.Description,
                Status: row.Status,
                Seller: row.SellerID._id,
                Type: row.Type,
                Amount: row.Amount,
                AmountToTransfer:row.AmountToTransfer ? row.AmountToTransfer:'',
                selectedService: row.PickupID ? row.PickupID._id : {},
                selectedProduct: row.ProductID ? row.ProductID._id : {},
                sellerProducts: [],
                PayoutPercentage: row.Type == 'Sale' ? row.SaleData.PayoutPercentage : '',
                ProductBasePriceWithDiscount: row.Type == 'Sale' ? row.SaleData.ProductBasePriceWithDiscount : '',
            }
        });
    }

    checkPayoutNotIncludeSeveralFeeTransactions() {
        var totalPayout = 0
        var payoutCorrect = true
        try{
            totalPayout = this.calculateTotalPayout();
        }catch(error){
            payoutCorrect = false
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': error.message
            });
        }

        if (totalPayout < 0) {
            
            var feeTransactions = _.filter(this.props.adminTransactions.selectedTransactions, function (transactionID) {
                var record = getTransaction(transactionID)

                return record.Type == 'PickupFee' || record.Type == 'Fee'
            }.bind(this))

            if (_.size(feeTransactions) > 1) {
                payoutCorrect = false
            }
        }
        return {success: payoutCorrect, totalPayout: totalPayout};
    }

    checkPaidTransactions() {
        for(let index = 0; index < this.props.adminTransactions.selectedTransactions.length ; index++) {
            let recordID = this.props.adminTransactions.selectedTransactions[index]
            var transaction = this.getTransaction(recordID)
    
            if (_.isUndefined(transaction)) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': `Selected transaction number (${recordID}) not found and not included in total payout`
                });
                return true;
            } else if (!_.includes(['Sold', 'PendingPayout','Paid'], transaction.Status)  ) {
                let messageCode = transaction.Status == 'Paid' ? `Transaction number (${recordID}) is already Paid` : `Transaction number (${recordID}) must be in Sold or Pending Payout status`
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': messageCode 
                });
                return true;
            }else if (transaction.PayoutID) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': `Transaction number (${recordID}) already has PayoutID value`
                });
                return true;
            }
        }
        return false;
    }

    completePayout() {
        this.setState({pending: true});
        var self = this;
        if (this.checkPaidTransactions()) {
            this.setState({pending: false});
            return false;
        }

        if (!this.checkPayoutNotIncludeSeveralFeeTransactions().success) {
            this.setState({pending: false});
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Payout with negative balance can not include more than one PickupFee or Fee transaction'
            });
        }
        var PayoutID = uuidv4(),maximumTransactionsNumber =config.getEnvironmentName() == 'local'  ?100:25000 ;
        var FeeTransactionID = _.find(self.props.adminTransactions.selectedTransactions, function (recordID, index) {
            var transaction = self.getTransaction(recordID)
            
            if (transaction.Type == 'PickupFee' || transaction.Type == 'Fee') {
                return true
            }
        })

        var FeeTransaction = self.getTransaction(FeeTransactionID)


        var functionsToPerform = [];
        var totalPayout = 0
        try{
            totalPayout = self.calculateTotalPayout();
        }catch(error) {
             this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': error.message
            });
        }
        
        
        if (totalPayout > 0) {

            functionsToPerform.push(function (done) {
                var methodData = {
                    "endpoint": "/transactions/process_payout_payment",
                    not_display_success_message: true,
                    "type": 'post',
                    timeout: 125000,
                };
                var error = false, transactionsData =[]
                _.forEach(self.props.adminTransactions.selectedTransactions, selectedTransactionID=>{
                    var data = { _id:selectedTransactionID }
                    var transaction = self.getTransaction(selectedTransactionID)
                    

                     if (_.isUndefined(transaction)) {
                        error ={
                            'messageType': 'warning',
                            'messageCode': 'Selected transaction not found'
                        }
                        return false
                    }

                    if (transaction.Type == 'Sale') {
                       data.PayoutAmount = calculateTransactionPayoutAmount(transaction, self.props.appData.FeatureFlags);
                     }
                    transactionsData.push(data)
                })
                if (error){
                    self.props.displayMessage(error)
                    return done(true)
                }
                var params = {
                    PayoutID: PayoutID,
                    totalPayout: formatNumbers.toFixed(totalPayout, 2),
                    transactionsData:transactionsData
                 };
                if (self.state.PayoutNote) {
                    params.PayoutNote = self.state.PayoutNote
                }
                if (self.props.adminTransactions.selectedTransactions.length  > maximumTransactionsNumber) {
                    if (self.state.sendEmailToUser) {
                        params.sendEmailToUser = true;
                    }
                    params.processInBackground =true
                }

                self.props.makeRequest(params, methodData).then(function (res) {
                    done(null)
                }).catch(err => {
                    if (!(self.props.adminTransactions.selectedTransactions.length > maximumTransactionsNumber)) {
                        self.props.displayMessage({
                            'messageType': 'warning',
                            messageCode: 'sellerPayoutConfirmationNotSent'
                        });
                    }
                    done(err)
                });
            })

            if (!(self.props.adminTransactions.selectedTransactions.length > maximumTransactionsNumber)) {
                sendSellerConfirmEmail()
            }

        } else {
            if (!FeeTransaction) {
                self.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Can not found PickupFee or Fee transaction to adjust negative Payout balance'
                });
            }

            /*send confirm email before updating the transactions, so that email include correct Pickup fee amounts */
            sendSellerConfirmEmail()

            functionsToPerform.push(function (done) {
                var methodData = {
                    "endpoint": "/transactions/" + encodeURIComponent(FeeTransaction._id),
                    'success_event': UPDATE_TRANSACTION,
                    "type": 'patch',
                    'not_display_success_message': true,
                };

                var updateParams = {
                    Amount: formatNumbers.unformat(formatNumbers.toFixed(FeeTransaction.Amount - Math.abs(totalPayout), 2)) /* decrease PickupFee by the negative total payout amount */
                }

                if (self.state.PayoutNote) {
                    updateParams.PayoutNote = self.state.PayoutNote
                }

                self.props.makeRequest(updateParams, methodData).then(function (res) {
                    done(null)
                }).catch(err => {
                    done(err)
                });
            })

            functionsToPerform.push(function (done) {
                var transactionToCreate = {
                    Type: FeeTransaction.Type,
                    FulfilledAt: new Date(),
                    Description: 'White Glove Service Fee (remaining balance due)',
                    Status: 'Sold',
                    SellerID: FeeTransaction.SellerID._id,
                    Amount: formatNumbers.unformat(formatNumbers.toFixed(Math.abs(totalPayout), 2))
                }

                var methodData = {
                    "endpoint": "/transactions",
                    'success_event': ADD_TRANSACTION,
                    "type": 'post',
                    messageData: {'#1#': 'Transaction'},
                    messageCode: 'recordAdded'
                };

                self.props.makeRequest(transactionToCreate, methodData).then(function (res) {
                    done(null)
                }).catch(err => {
                    done(err)
                });
            })
        }

        async.series(functionsToPerform,
            function (err, responses) {
                self.setState({pending: false});
                if (err) {
                    return
                }
                var   message='Payout completed'
                  if (self.props.adminTransactions.selectedTransactions.length > maximumTransactionsNumber) {
                    message = 'Payout processing action with ID ' + PayoutID + ' started. Confirmation email will be sent at ' + self.props.userReducer.user.email
                }
                  self.props.displayMessage({
                        'messageType': 'success',
                        'messageCode': message
                });

                self.setState({displayGeneratePayoutBox: false, PayoutNote: ''});
                self.props.dispatchAction({}, CLEAR_SELECTED_TRANSACTIONS)
            })

        function sendSellerConfirmEmail() {
            functionsToPerform.push(function (done) {
                var methodData = {
                    "endpoint": "/transactions/confirm_payout",
                    not_display_success_message: true,
                    "type": 'post'
                };

                var params = {
                    totalPayout: totalPayout,
                    recordIDs: self.props.adminTransactions.selectedTransactions
                };

                if (self.state.PayoutNote) {
                    params.PayoutNote = self.state.PayoutNote
                }

                if (self.state.sendEmailToUser) {
                    params.sendEmailToUser = true;
                }

                self.props.makeRequest(params, methodData).then(function (res) {
                    done(null)
                }).catch(err => {
                    self.props.displayMessage({
                        'messageType': 'warning',
                        messageCode: 'sellerPayoutConfirmationNotSent'
                    });
                    done(err)
                });
            })
        }
    }

    /**
     * Functions related to calculate the payout
     * @param {*} params doNotReturnError it won't let the function break if the record is null in transaction.data. Instead it will display a message
     * 
     * @returns 
     */
    calculateTotalPayout(params = {}) {
         var totalPayout = 0;
        for(let index = 0; index < this.props.adminTransactions.selectedTransactions.length ; index++) {
            let recordID = this.props.adminTransactions.selectedTransactions[index]
            var record = this.getTransaction(recordID)

            if (_.isUndefined(record)) {
              throw new Error(`Selected transaction ${recordID} is not found and not included in Total payout`);
            }

            // This should be returning an error, right?
            if (record.Type == 'Sale') {
              if (_.isUndefined(record.SaleData.PayoutPercentage)) {
                throw new Error('Product payout is not available in transaction record');
              }

              totalPayout += calculateTransactionPayoutAmount(record, this.props.appData.FeatureFlags);
            } else if (record.Type == 'Credit' || record.Type == 'WorkingTime') {
                totalPayout += formatNumbers.unformat(formatNumbers.toFixed(record.Amount, 2))
            } else if (record.Type == 'Fee' || record.Type == 'PickupFee')  {
                totalPayout -= formatNumbers.unformat(formatNumbers.toFixed(record.Amount, 2))
            }
        }
        return totalPayout
    }

    validateAndGetFormData() {
        var formData = {}
        const currentTime = new Date()
        if (this.state.formData.Type == '') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Type field is required',
            });
            return false;
        }

        formData.Type = this.state.formData.Type;
        if (this.state.formData.Status == '') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Status field is required',
            });
            return false;
        }

        formData.Status = this.state.formData.Status;
        if (this.state.formData.Description == '') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Description field is required',
            });
            return false;
        }

        formData.Description = this.state.formData.Description;
        if(formData.Type == 'Credit'  && formData.Description.toLowerCase().includes('buyback')){
            formData.FundsAvailableForPaymentDate = currentTime
        }
        if (this.state.formData.Amount == '') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Amount field is required',
            });
            return false;
        }

        if (formData.Type == 'Sale') {

            if (this.state.formData.PayoutPercentage !== '') {
                formData.PayoutPercentage = this.state.formData.PayoutPercentage;
            }

            if (this.state.formData.OrderID !== '') {
                formData.OrderID = this.state.formData.OrderID;
            }

        }

        formData.Amount = this.state.formData.Amount;
        if (!_.get(this.state,'currentRecord._id') && formData.Type == 'Sale' && typeof this.state.formData.selectedProduct !== 'string') {
            this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Please, select a product',
            });
            return false;
        }

        if (typeof this.state.formData.selectedProduct == 'string') {
            formData.ProductID = this.state.formData.selectedProduct;
        }

        if (typeof this.state.formData.selectedService == 'string') {
            formData.PickupIDBase64 = this.state.formData.selectedService;
        }

        if (!_.get(this.state,'currentRecord._id')) { /* this is new transaction*/
            formData.SellerID = this.state.SellerID ? this.state.SellerID : (this.state.formData.Seller ? this.state.formData.Seller : false)
            
            if (!formData.SellerID) {
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': 'Please, select a seller',
                });
                return false;
            }

            if (  formData.Status !== 'Pending') {
                formData.FulfilledAt = currentTime
            }
        }
        return formData
    }

    closeModal() {
        this.setState({
            showAddFeeModal: false,
            currentRecord: {},
            formData: {
                Description: '',
                Seller: false,
                Status: '',
                Type: '',
                Amount: '',
                selectedProduct: {},
                sellerProducts: [],
            }
        });
    }

    onSortChange(field, sortOrder) {
        this.setState({sortBy: field + ':' + (sortOrder == 'asc' ? 1 : -1)}, function () {
            if (this.refs.pagination) {
                this.refs.pagination.resetPagination();
            }
            this.search()
        })
    }

    sendTransactionsUpdateEmails() {
        this.setState({pending: true});

        var self = this;

        var methodData = {
            "endpoint": "/transactions/send_transactions_update_emails",
            "type": 'post'
        };
        var params = {
            transactionIDs: self.props.adminTransactions.selectedTransactions,
        };

        self.props.makeRequest(params, methodData).then(function (res) {
            self.setState({pending: false});
            return self.props.displayMessage(res.data);
        }).catch(err => {
            self.setState({pending: false});
        });
    }

    /**Get the transaction by id from adminTransactions */
    getTransaction(recordId){
        return this.props.adminTransactions.dataHash[recordId]
    }

    /** 
     * Button that generates the payout
     */
    generatePayout() {
        
        if (this.checkPaidTransactions()) {
            return false;
        }
        
        let payoutReturn = this.checkPayoutNotIncludeSeveralFeeTransactions()

        if (!payoutReturn.success) {
            return this.props.displayMessage({
                'messageType': 'warning',
                'messageCode': 'Payout with negative balance can not include more than one PickupFee or Fee transaction'
            });
        }
        
        this.setState({displayGeneratePayoutBox: true})
        return payoutReturn
    }
    transferAmountToNewFeeTransaction(){
        var functionsToCall = [],self =this, formData = {
              MarketName:this.state.currentRecord.MarketName,
             ProductID:this.state.currentRecord.ProductID ? this.state.currentRecord.ProductID._id:undefined,
             PickupIDBase64:this.state.currentRecord.PickupID ? this.state.currentRecord.PickupID:undefined,
             SellerID:this.state.currentRecord.SellerID._id,
             Type:'Fee',
             Status:'Pending',
             Description:'Transfer of $'+this.state.formData.AmountToTransfer,
            Amount: this.state.formData.AmountToTransfer,
             CustomData:{
                AmountFromTransactionID:base64ToHex(this.state.currentRecord._id, {convertToHEXUUID:true}),
                TransactionAmountBeforeTransfer:this.state.currentRecord.Amount,
             }
        }
        functionsToCall.push( function (done) {
            self.props.makeRequest(formData, {
                "endpoint": "/transactions",
                type: "post",
            }).then(res => {

                  self.props.displayMessage({
                     'messageCode': 'New Fee with $'+self.state.formData.AmountToTransfer + ' created',
                });
                done(null)
            }).catch(err => {
                console.log('err', err  );
                done(err)
            });
        })
        functionsToCall.push( function (done) {
              self.saveRecord.call(self).then(()=>{
                   done(null)
              }).catch(err => {
                   done(err)
              });
        })
        async.series(functionsToCall,
            function (err, responses) {
                 if (err) {
                    console.log('err 1', err  );
                 }
                self.setState({
                    pending:false,
                    showAddFeeModal: false,
                    currentRecord: {},
                    formData: {
                        Description: '',
                        Seller: false,
                        Status: '',
                        Type: '',
                        Amount: '',
                        selectedProduct: {},
                        selectedService: {},
                        sellerProducts: [],
                        sellerServices: [],
                    }
                })
            })

    }
    saveRecord(e=false) {
        if(e) {
            e.preventDefault();
        }
        var formData = this.validateAndGetFormData();
        if (!formData) {
            return false;
        }

        var methodData
        if (_.get(this.state,'currentRecord._id')) {
            methodData = {
                "endpoint": "/transactions/" + encodeURIComponent(_.get(this.state,'currentRecord._id')),
                type: "patch",
                success_event: UPDATE_TRANSACTION,
                messageData: {'#1#': 'Transaction'},
                messageCode: 'recordUpdated'
            };
        } else {
            methodData = {
                "endpoint": "/transactions",
                type: "post",
                success_event: ADD_TRANSACTION,
                messageData: {'#1#': 'Transaction'},
                messageCode: 'recordAdded'
            };
        }


       return this.props.makeRequest(formData, methodData).then(res => {
            this.setState({
                showAddFeeModal: false,
                currentRecord: {},
                formData: {
                    Description: '',
                    Seller: false,
                    Status: '',
                    Type: '',
                    Amount: '',
                    selectedProduct: {},
                    selectedService:{},
                    sellerProducts: [],
                    sellerServices: [],
                }

            })
        }).catch(err => {
           return Promise.reject(err);
        });

    }

    openModal() {
        if (this.state.SellerID) {
            this.onFormSellerChange({value: this.state.SellerID});
        }
        this.setState({showAddFeeModal: true})
    }

    onFormSellerChange(option) {
        var self = this
        this.setState({'formData': {...this.state.formData, Seller: option.value}}, function () {

            var functionsToCall = {};

            functionsToCall['sellerProducts'] = function (done) {
                self.props.makeRequest({
                    SellerID: self.state.formData.Seller,
                    all: true,
                    listingStatuses: ['Listings'],
                    lookup: ['SellerID'],
                    status: 'all'
                }, {
                    'endpoint': '/products',
                    'not_display_success_message': true,
                }).then(function (res) {
                    done(null, res.data)
                }).catch(err => {
                    done(err)
                });
            }

            functionsToCall['sellerServices'] = function (done) {
                self.props.makeRequest({
                    SellerID: self.state.formData.Seller,
                    all: true,
                    lookup: ['SellerID'],

                }, {
                    'endpoint': '/pickups',
                    'not_display_success_message': true,
                }).then(function (res) {
                    done(null, res.data)
                }).catch(err => {
                    done(err)
                });

            }

            async.parallel(functionsToCall,
                function (err, results) {
                    if (err) {
                        return
                    }
                    self.setState({
                        'formData': {
                            ...self.state.formData,
                            sellerProducts: results['sellerProducts'].data,
                            sellerServices: results['sellerServices'].data
                        }
                    });
                })
        })

    }

    render() {

        const {state:{ filterOptions:{Statuses=[]} = {} }={}  } =  this.searchBox || {}
        const {value:firstStatusValue=''}=Statuses[0] || {}
        const {AmountToTransfer = 0} = this.state.formData || {}
        const statusValues = Statuses.map(item=>{
            return item.value
        })

        var allowGeneratePayout =false
        if (Statuses.length  ==1 &&  ['Sold','PendingPayout'].includes(firstStatusValue )){
            allowGeneratePayout = true
        }else if (Statuses.length  ==2 &&   _.difference(['Sold','PendingPayout'],statusValues).length==0 ){
            allowGeneratePayout = true
        }
        var totalPayout = 0;
        if(this.props.adminTransactions.selectedTransactions.length > 0 &&_.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0 && this.props.adminTransactions.total > 0 && this.state.SellerID && allowGeneratePayout){
            try{
                totalPayout = this.calculateTotalPayout();
                totalPayout = ((totalPayout == 0 ? '' : totalPayout > 0 ? '+' : '-') + '$' + formatNumbers.toFixed(Math.abs(totalPayout), 2))
            }catch(error) {
                 totalPayout = 'N/A';
                this.props.displayMessage({
                    'messageType': 'warning',
                    'messageCode': error.message
                });
            }
        }
        
        var filteredStatusOptions;

        if (this.state.formData.Type == 'Sale') {
            filteredStatusOptions = _.reject(config.transactionStatusMap, {value: 'Returned'})
        } else if (this.state.formData.Type == 'Credit') {
            filteredStatusOptions = _.filter(config.transactionStatusMap, (option) => {
                return _.includes(['Sold', 'Paid'], option.value)
            })
        } else {
            filteredStatusOptions = config.transactionStatusMap
        }

        // Returning the component
        return (
            <div className="admin-transactions-page">
                {config.checkAccessRights.call(this, {resources: ['payout_registry_full']}) &&
                <AdminTransactionsActionsBox selectAllRecords={this.state.selectAllRecords}
                                             search={this.search.bind(this)}
                                             toggleAllRecordsSelection={this.toggleAllRecordsSelection.bind(this)}    {...this.props} ></AdminTransactionsActionsBox>
                }
                {this.state.displayGeneratePayoutBox && this.state.SellerID &&   allowGeneratePayout &&
                <div className="blue top20">
                    <h4 className="bold-text">Generate Payout</h4>
                    <Row className="pleft15 top15">
                        <Col className="top8" xs={12}>Payout Method
                            = {_.get(this.props.adminTransactions.data[0], ['SellerID', 'PaymentMethod'], '')  } </Col>
                        <Col className="top8" xs={12}>Payout Account
                            = {_.get(this.props.adminTransactions.data[0], ['SellerID', 'PaymentMethod'], '') == 'Check' ?
                                _.get(this.state.selectedUser, ['UserID', 'firstName'], '') + ' ' + _.get(this.state.selectedUser, ['UserID', 'lastName'], '') :
                                _.get(this.props.adminTransactions.data[0], ['SellerID', 'PaymentData', _.get(this.props.adminTransactions.data[0], ['SellerID', 'PaymentMethod'], ''), 'email'], 'n/a')
                            }</Col>
                        <Col className="top8" xs={12}><span className="right10">Payout Amount</span>
                            <span
                                className="green">{totalPayout}</span></Col>
                        <Col className="top8 pull-left" xs={6}>
                            <span>Internal Comment</span>

                            <span className="left10">
                        <FormControl style={{'display': 'inline', 'width': 'auto'}} type="text"
                                     onChange={(e) => this.setState({'PayoutNote': e.target.value})}
                                     value={this.state.PayoutNote }
                                     placeholder=""/>
                    </span>
                        </Col>
                        <Col className="top8" xs={12}>
                            <Checkbox onChange={(e) => this.setState({sendEmailToUser: !this.state.sendEmailToUser})}
                                      checked={this.state.sendEmailToUser} inline><span className="left5">Send Customer Invoice (via email)</span></Checkbox>
                        </Col>
                        <Col xs={12} className="top10">
                            <Button
                                disabled={this.props.adminTransactions.selectedTransactions.length == 0 || this.state.pending}
                                className="btn btn-primary" onClick={(e) => this.completePayout()}>
                                Complete Payout
                            </Button>
                        </Col>
                    </Row>
                </div>
                }
                <AdminTransactionsSearchBox
                    matchingFeeTransactions={this.state.matchingFeeTransactions}
                    prepareTransactionsForPayment={this.prepareTransactionsForPayment.bind(this)}
                    searchFeeTransactions={this.searchFeeTransactions.bind(this)} allowGeneratePayout={allowGeneratePayout} pending={this.state.pending}
                                            ref={(searchBox) => {
                        if (searchBox && !this.searchBox) {
                            this.searchBox = searchBox;
                            if (_.size(_.get(this.props.location.query, 'recordIDs', []))  ) { /* by default search only if recordIDs are passed*/
                                this.search()
                            }
                        }
                    } }
                    sellersOptionsList={ this.state.sellersOptionsList}
                    search={this.search.bind(this)}
                    resetSearch={this.resetSearch.bind(this)}
                    fetchSelectedUserData={this.fetchSelectedUserData.bind(this)}
                    toggleAllRecordsSelection={this.toggleAllRecordsSelection.bind(this)}
                    foundSellersList={this.state.foundSellersList}
                    {...this.props} >
                        
                </AdminTransactionsSearchBox>
                {this.props.adminTransactions.fetched && this.state.selectedUser &&
                < Row className="top20 blue">
                    <Col xs={5} className="pull-left">
                        <div>{this.state.selectedUser.DisplayName}</div>
                        <div
                            className="top5">{this.state.selectedUser.UserID.firstName + (this.state.selectedUser.UserID.lastName ? ' ' + this.state.selectedUser.UserID.lastName : '') }</div>
                        <div className="underlineText top5">{this.state.selectedUser.UserID.email}</div>
                    </Col>

                    <Col xs={5} className="text-right pull-right">
                        <div>{this.state.selectedUser.Payout + '%'}</div>
                        {_.get(this.state.selectedUser, ['PickupAddress', 'Street']) &&
                        <div className="top5">{_.get(this.state.selectedUser, ['PickupAddress', 'Street'], '')
                        + ', ' + _.get(this.state.selectedUser, ['PickupAddress', 'City'], '') + ', ' + _.get(this.state.selectedUser, ['PickupAddress', 'State'], '')
                        + ', ' + _.get(this.state.selectedUser, ['PickupAddress', 'Zip'], '') }</div>
                        }
                    </Col>

                </Row>
                }
                {this.props.adminTransactions.fetched &&
                <div>
                    {  this.props.adminTransactions.total == 0 ?
                        <div
                            className="messageBox">{config.clientMessages.noRecordsFoundForCriteria.replace("#1#", 'Transactions')}</div> :
                        <div className="top20">
                            <AdminTransactionsListTable
                                data={this.state.dataToDisplay.length > 0 ? this.state.dataToDisplay : this.props.adminTransactions.data}
                                onSortChange={this.onSortChange.bind(this)}
                                showRemoveDialog={this.showRemoveDialog.bind(this)}
                                editTransaction={this.editTransaction.bind(this)}
                                setSearchParams={this.setSearchParams.bind(this)}
                                search={this.search.bind(this)}  {...this.props}  ></AdminTransactionsListTable>

                            <PaginationBox
                                ref={'pagination'}
                                perPage={(this.props.adminTransactions.total ==_.size(this.props.adminTransactions.data) && _.size(this.state.dataToDisplay) ==0)?
                                    undefined:
                                    (this.searchBox ? this.searchBox.state.filterOptions.perPage : _.get(queryString.parse(this.props.location.search), ['perPage'], undefined))}
                                total={  this.props.adminTransactions.total}
                                search={this.search.bind(this)}>
                            </PaginationBox>

                        </div>}


                    {_.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0 &&
                    <div className="pull-right">
                        <button className="left20 btn btn-primary"
                                onClick={this.openModal.bind(this)}
                                type="button">
                            Add Fee
                        </button>
                    </div>
                    }
                    
                    { _.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0 && this.props.adminTransactions.fetched && this.props.adminTransactions.total > 0 &&
                    <div className="pull-right">
                        <button className="btn btn-primary left20"
                                disabled={this.props.adminTransactions.selectedTransactions.length == 0 || this.state.pending}
                                onClick={  this.sendTransactionsUpdateEmails.bind(this)}
                                type="button">
                            Send update email
                        </button>
                    </div>
                    }

                </div>
                }
                
                {_.size(_.intersection(this.props.userReducer.user.Roles, ['Administrator'])) > 0 
                && this.props.adminTransactions.fetched 
                && this.props.adminTransactions.total > 0 
                && this.state.SellerID 
                && allowGeneratePayout &&
                <div className="pull-right">
                    <h3 className="green top5 right20 pull-left ">{totalPayout}</h3>
                    <button className="btn btn-primary left20"
                            onClick={  this.generatePayout.bind(this)}
                            disabled={this.props.adminTransactions.selectedTransactions.length == 0 || this.state.pending}
                            type="button">
                        Generate Payout
                    </button>
                </div>
                }

                <Modal onExited={this.closeModal.bind(this)} show={this.state.showAddFeeModal}
                       onHide={(e) => this.setState({showAddFeeModal: false})}>
                
                    <Modal.Header closeButton>
                        <Modal.Title>{_.get(this.state,'currentRecord._id') ? 'Edit' : 'Add new'}</Modal.Title>
                    </Modal.Header>

                    <Modal.Body>
                        <Form  >
                            {!_.get(this.state,'currentRecord._id') &&
                            <FormGroup>
                                <ControlLabel>Type</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    clearable={false}
                                    placeholder=""
                                    options={transactionTypes}
                                    onChange={(option) => this.setState({
                                        'formData': {
                                            ...this.state.formData,
                                            selectedService:{},
                                            Type: option.value
                                        }
                                    })}
                                    value={this.state.formData.Type}
                                />
                            </FormGroup>}

                            <FormGroup>
                                <ControlLabel>Description</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'formData': {
                                                     ...this.state.formData,
                                                     Description: e.target.value
                                                 }
                                             })}
                                             onFocus={(e) => this.setState({
                                                 errors: {
                                                     ...this.state.errors,
                                                     Description: false
                                                 }
                                             }) }
                                             value={this.state.formData.Description }
                                             style={this.state.errors['Description'] ? {border: '1px solid red'} : {} }
                                             placeholder="Description"/>
                            </FormGroup>
                            
                            {_.get(this.state, 'currentRecord.Status') !== 'Paid' &&
                            <FormGroup>
                                <ControlLabel>Status</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    placeholder="Status"
                                    clearable={false}
                                    options={filteredStatusOptions }
                                    onChange={(option) => this.setState({
                                        'formData': {
                                            ...this.state.formData,
                                            Status: option.value
                                        }
                                    })}
                                    value={this.state.formData.Status}
                                />
                            </FormGroup>}

                            <FormGroup>
                                <ControlLabel>Amount</ControlLabel>
                                <FormControl type="text" disabled={  AmountToTransfer > 0}
                                             onChange={(e) => this.setState({
                                                 'formData': {
                                                     ...this.state.formData,
                                                     Amount: e.target.value
                                                 }
                                             })}
                                             onFocus={(e) => this.setState({
                                                 errors: {
                                                     ...this.state.errors,
                                                                Amount: false
                                                 }
                                             }) }
                                             value={this.state.formData.Amount }
                                             style={this.state.errors['Amount'] ? {border: '1px solid red'} : {} }
                                             placeholder="Amount"/>
                            </FormGroup>

                          { (this.state.currentRecord && this.state.formData.Type == 'Sale' && this.state.formData.ProductBasePriceWithDiscount ) &&
                            <FormGroup>
                              <ControlLabel>Base Price with discount</ControlLabel>
                              <FormControl type="text" disabled={true}
                                           value={this.state.formData.ProductBasePriceWithDiscount }
                                            />
                            </FormGroup>}
                            { _.get(this.state,'currentRecord._id') && this.state.formData.Type == 'Sale' &&
                            <FormGroup>
                                <ControlLabel>Payout Percentage</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'formData': {
                                                     ...this.state.formData,
                                                     PayoutPercentage: e.target.value
                                                 }
                                             })}

                                             value={this.state.formData.PayoutPercentage }
                                             placeholder="Payout Percentage"/>
                            </FormGroup>}


                            {!isNaN(_.get(this.state.formData,'PayoutPercentage')) && !isNaN(_.get(this.state.formData,'Amount')) &&  this.state.formData.Type == 'Sale' &&
                            <div >
                                <span>Payout amount</span>
                                <span> {formatNumbers.formatMoney(calculateTransactionPayoutAmount({
                                  Amount: this.state.formData.Amount,
                                  SaleData: {
                                    PayoutPercentage: this.state.formData.PayoutPercentage,
                                    ProductBasePriceWithDiscount: this.state.formData.ProductBasePriceWithDiscount,
                                  }
                                },this.props.appData.FeatureFlags))}</span>
                            </div>}
                            { _.get(this.state,'currentRecord._id') && this.state.formData.Type == 'Fee' &&
                                <FormGroup>
                                    <ControlLabel>Transfer amount to new fee</ControlLabel>
                                    <FormControl type="text"
                                                 onChange={(e) => {
                                                     let amountToTransfer =      e.target.value

                                                     if(amountToTransfer !== ''){
                                                       if (isNaN(amountToTransfer)) {
                                                           return this.props.displayMessage({
                                                               'messageType': 'warning',
                                                               'messageCode': 'Please, specify valid amount'
                                                           });
                                                       }
                                                       if ((this.state.currentRecord.Amount - amountToTransfer) <= 0) {
                                                           return this.props.displayMessage({
                                                               'messageType': 'warning',
                                                               'messageCode': 'New amount must be greater than 0'
                                                           });
                                                       }
                                                       var matchDecimal = amountToTransfer.match(/^(\d+[\.,,]?\d{0,2})(\d*)$/)
                                                        if(matchDecimal && matchDecimal[2]){ /* if more than 3 decimails are used, replace them with only 2 decimals*/
                                                            amountToTransfer =   matchDecimal[1]
                                                       }
                                                    }
                                                      
                                                     this.setState({
                                                         'formData': {
                                                             ...this.state.formData,
                                                             Amount:formatNumbers.unformat(formatNumbers.toFixed(this.state.currentRecord.Amount - amountToTransfer,2)),
                                                             AmountToTransfer: amountToTransfer
                                                         }
                                                     })
                                                 }}
                                                 value={this.state.formData.AmountToTransfer }
                                                 placeholder="Amount to transfer"/>
                                </FormGroup>}
                            {AmountToTransfer > 0 &&
                                <Button className=" right0   btn btn-primary " type="button" disabled={this.state.formData.pending}
                                        onClick={()=>{
                                            if(this.state.formData.pending){
                                                return
                                            }
                                            this.setState({
                                                'formData': {
                                                    ...this.state.formData,
                                                    pending:true}},()=>{
                                                             this.transferAmountToNewFeeTransaction.call(this)
                                            })}}  >
                                    {'Transfer $'+AmountToTransfer + ' from this fee to a  new fee'}
                                </Button>}
                            { !_.get(this.state,'currentRecord._id') && this.state.formData.Type == 'Sale' &&
                            <FormGroup>
                                <ControlLabel>Order ID</ControlLabel>
                                <FormControl type="text"
                                             onChange={(e) => this.setState({
                                                 'formData': {
                                                     ...this.state.formData,
                                                     OrderID: e.target.value
                                                 }
                                             })}

                                             value={this.state.formData.OrderID }
                                             placeholder="Order ID"/>
                            </FormGroup>}

                            { !_.get(this.state,'currentRecord._id') && !this.state.SellerID &&
                            <FormGroup>
                                <ControlLabel>Seller</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    isOpen={true}
                                    placeholder="Seller"
                                    clearable={false}
                                    options={this.state.sellersOptionsList}
                                    onChange={this.onFormSellerChange.bind(this)}
                                    value={this.state.formData.Seller}
                                />
                            </FormGroup>}

                            {!_.get(this.state,'currentRecord._id') && (this.state.formData.Type == 'Fee' || this.state.formData.Type == 'Sale') &&
                            <FormGroup>
                                <ControlLabel>Seller products</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    style={this.state.errors['selectedProduct'] ? {border: '1px solid red'} : {} }
                                    searchable={true}
                                    clearable={false}
                                    placeholder=""
                                    options={  _.map(this.state.formData.sellerProducts, function (product) {
                                        return {label: product.ProductName + ' $' + product.Price, value: product._id}
                                    }) }
                                    onChange={ (option) => this.setState({
                                        'formData': {
                                            ...this.state.formData,
                                            selectedProduct: option ? option.value : {},
                                        }
                                    })}

                                    value={this.state.formData.selectedProduct }
                                />
                            </FormGroup>}

                            {!_.get(this.state,'currentRecord._id') && (this.state.formData.Type == 'Fee' || this.state.formData.Type == 'PickupFee') &&
                            <FormGroup>
                                <ControlLabel>Seller services</ControlLabel>
                                <Select
                                    tabIndex="0"
                                    style={this.state.errors['selectedService'] ? {border: '1px solid red'} : {} }
                                    searchable={true}
                                    clearable={false}
                                    placeholder=""
                                    options={  _.map(this.state.formData.sellerServices, function (item) {
                                        return {label: item.Type +  ' ' + item.PickupNumber, value: item._id}
                                    }) }
                                    onChange={ (option) => this.setState({
                                        'formData': {
                                            ...this.state.formData,
                                            selectedService: option ? option.value : {},
                                        }
                                    })}
                                    value={this.state.formData.selectedService }
                                />
                            </FormGroup>}
                            
                        </Form>

                    </Modal.Body>
                    <Modal.Footer className="top20">
                        <Row className="left0">
                            <Col md={12} sm={12} xs={12} className="pleft0">
                                <Button className=" right0 pull-right btn btn-primary " type="button"
                                        onClick={this.saveRecord.bind(this) }>
                                    Save
                                </Button>
                                <Button className="pull-right btn right20 btn-default" type="button"
                                        onClick={(e) => this.closeModal() }>
                                    Cancel
                                </Button>
                            </Col>
                        </Row>
                    </Modal.Footer>
                </Modal>
                <RemoveModalDialog
                    show={this.state.removeRecordModalVisible}
                    removeRecord={(e) => this.deleteTransaction() }
                    closeModal={(e) => this.setState({currentRecord: false, removeRecordModalVisible: false})}>
                </RemoveModalDialog>
                {this.state.pending &&
                <div className="pending-box"></div>
                }
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        'adminTransactions': state.adminTransactions,
        allContractorsList: state.allContractorsList,
        userReducer: state.userReducer,
        appData: state.appData,
        allSellersList: state.allSellersList
    };

}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, displayMessage, dispatchAction}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TransactionsPage);
